import { FileImage } from "lucide-react";
import { useState, useEffect } from "react";

const UploadImage = ({
  diagrams,
  onFileSelect,
  onRemove,
  onDescriptionChange,
  onSubmit,
  fileInputRef,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const current = diagrams[activeIndex];

  useEffect(() => {
    setActiveIndex(0);
  }, [diagrams.length]);

  
  const handleNext = () => {
    if (!current?.description?.trim()) return; 
    setActiveIndex((prev) => {
      const nextIndex = prev + 1;
  
      if (nextIndex < diagrams.length) {
        if (!diagrams[nextIndex].description) {
          onDescriptionChange(diagrams[nextIndex].id, "");
        }
      }
  
      if (prev === diagrams.length - 1) {
        onSubmit();
        return prev;
      }
  
      return nextIndex;
    });
  };
  

  const handlePrevious = () => {
    setActiveIndex((i) => Math.max(0, i - 1));
  };

  const handleRemoveCurrent = () => {
    onRemove(current.id);
    setActiveIndex((i) => Math.max(0, i - 1));
  };

  return (
    <>
      <div
        onClick={() => fileInputRef.current.click()}
        className="border-dashed border-2 border-indigo-400 rounded-xl p-12 text-center cursor-pointer bg-indigo-50 hover:bg-indigo-100"
      >
        <FileImage size={48} className="mx-auto text-indigo-500 mb-3" />
        <p className="font-semibold text-black">
          Click or Drag & Drop ER Diagrams
        </p>
        <p className="text-sm text-gray-500">
          Max 5MB • JPG/PNG • 1920×1080 recommended
        </p>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        multiple
        accept="image/png,image/jpeg"
        hidden
        onChange={(e) => onFileSelect(e.target.files)}
      />

      {diagrams.length > 0 && current && (
        <div className="flex items-center justify-center ">
          <div className="mt-6 border rounded-lg w-[80%]  p-4 bg-indigo-50 ">
            <div className=" flex flex-col gap-1 mb-3">
              <h3 className="text-md font-semibold text-black">
                Add Description for Diagram {activeIndex + 1} of{" "}
                {diagrams.length}
              </h3>
              <p className="text-sm text-gray-500">
                Provide a description for this ER diagram to identify it later.
              </p>
            </div>

            <div className="w-full h-[260px] flex items-center justify-center bg-white rounded-md mb-4">
              <img
                src={current.preview}
                alt={current.name}
                className="max-h-full max-w-full object-contain"
              />
            </div>

            <label className="block font-medium mb-2 text-black">
              Description(Mandatory):
            </label>
            <textarea
              value={current.description}
              onChange={(e) => onDescriptionChange(current.id, e.target.value)}
              placeholder="e.g. User authentication and authorization schema"
              className="w-full border rounded-md p-3 text-sm resize-none text-black"
              rows={1}
            />

            <div className="flex justify-between items-center mt-4">
              <div>
                {activeIndex > 0 && (
                  <button
                    onClick={handlePrevious}
                    className="bg-[#bb1ccc] text-white px-4 py-2 border rounded-md text-sm"
                  >
                    Previous
                  </button>
                )}
              </div>

              <div className="flex gap-2">
                <button
                  onClick={handleRemoveCurrent}
                  className="bg-red-100 text-red-600 px-4 py-2 rounded-md"
                >
                  Remove
                </button>

                <button
                  onClick={handleNext}
                  disabled={!current.description.trim()}
                  className="bg-[#bb1ccc] text-white px-4 py-2 rounded-md disabled:opacity-40"
                >
                  {activeIndex === diagrams.length - 1 ? "Submit" : "Next"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadImage;
